import BluetoothManager from './bluetoothManager';
import MeasurementRecorder from './measurementRecorder';
import MeasurementManager from './measurementManager';

export enum State {
    Ready,
    Capturing,
    Stopped,
    Saving,
    Saved,
    SaveError,
}

export default class CaptureManager {

    private bluetooth: BluetoothManager;
    private recorder: MeasurementRecorder;
    private manager: MeasurementManager;

    private captureState: State;

    public constructor(bluetooth: BluetoothManager, options: any) {
        this.bluetooth = bluetooth;
        this.recorder = new MeasurementRecorder(options.exercise);
        this.manager = new MeasurementManager();
        this.bluetooth.on('data', (location, data) => {
            this.recorder.addSample(data, location);
        });
        this.captureState = State.Ready;
    }

    get state(): State {
        return this.captureState;
    }

    public start() {
        this.bluetooth.startNotifications();
        this.captureState = State.Capturing;
    }

    public stop() {
        this.bluetooth.stopNotifications();
        this.captureState = State.Stopped;
    }

    public save(): Promise<any> {
        return new Promise( (resolve, reject) => {
            this.captureState = State.Saving;
            this.manager.save(this.recorder.measurement)
            .then( (result) => {
                this.captureState = State.Saved;
                resolve();
            })
            .catch( (err) => {
                this.captureState = State.SaveError;
                reject(err);
            });
        });
    }

    public addLabel(label: string) {
        this.recorder.addLabel(label);
    }

    public getSampleCount() {
        return this.recorder.measurement.samples.length;
    }

    public getLabelCount() {
        return this.recorder.measurement.labels.length;
    }
}
